import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as actions from './redux/actions';
import { List, Button, Popconfirm, message } from "antd";
import { HEAD_DEFAULT, MyIcon } from "../../common/baseConfig";
import ExerRecordPane from "./ExerRecordPane";
import moment from "moment";
import NoneData from "../common/NoneData";
export class ExerRecordMyCorrection extends Component {
  state = {
    curPage: 1,
    checkIndex: -1,
  }
  static propTypes = {
    center: PropTypes.object.isRequired,
    actions: PropTypes.object.isRequired,
  };
  componentDidMount() {
    this.onLoadMyCorrection();
  }
  onLoadMyCorrection() {
    this.props.actions.fetchGetQuestionerrorCorrectionList({
      PageSize: 5,
      PageIndex: this.state.curPage,
      PageStatus: 1,
    })
  }
  getErrorType(type) {
    switch (type) {
      case 1:
        return "含有错别字";
      case 2:
        return "答案不正确";
      case 3:
        return "题目不完整";
      case 4:
        return "图片不存在";
      case 5:
        return "解析不正确";
      case 6:
        return "其他错误";
      default:
        break;
    }
  }
  delMyCorrection(ID) {
    this.props.actions.fetchDeleteMyCorrection({ ID }).then(res => {
      if (res.SuccessResponse) {
        message.success('删除成功');
        this.onLoadMyCorrection();
      }
    })
  }
  renderItem(item, key) {
    const { checkIndex } = this.state;
    const { studentBasics } = this.props.common;
    return (
      <div key={key} className="my-correction-item">
        <div className="my-correction-item-content">
          <div className="div1">
            <img src={studentBasics.HeadImg || HEAD_DEFAULT} alt="" />
            <h2>
              <p className="p1">
                <span>{studentBasics.Name}</span><span>{moment(new Date(item.QuestionErrorAddTime)).format('YYYY-MM-DD HH:mm:ss')}</span>
              </p>
              <p className="p2">
                纠错描述：{this.getErrorType(item.ErrorType)}
              </p>
              <p className="p3">
                {item.Remart}
              </p>
              <p className="p4">
                来源：【{item.TypeName}】{item.Title}
              </p>
            </h2>
          </div>
          <div className="div2">
            <Button type="theme" onClick={() => {
              if (checkIndex === item.ID) {
                this.setState({
                  checkIndex: -1,
                })
              } else {
                this.setState({
                  checkIndex: item.ID,
                })
              }
            }}>{checkIndex === item.ID ? "收起题目" : "查看题目"}</Button>
            <Popconfirm placement="top" title={"确认删除该纠错吗"} onConfirm={this.delMyCorrection.bind(this, item.QuestionerrorcorrectionID)} okText="确认" cancelText="取消">
              <p className="del"><MyIcon type="iconshanchu1" /></p>
            </Popconfirm>
          </div>
        </div>
        {
          checkIndex === item.ID &&
          <ExerRecordPane
            {...this.props}
            item={item}
            questionTypeName={item.TypeName}
            onLoad={this.onLoadMyCorrection.bind(this)}
          />
        }
      </div>
    )
  }
  render() {
    const {
      fetchGetQuestionerrorCorrectionListSuccess,
      fetchGetQuestionerrorCorrectionListTotal,
      fetchGetQuestionerrorCorrectionListPending,
    } = this.props.center;
    return (
      <div className="center-exer-record-my-correction">
        <h3>
          我的纠错
        </h3>
        {
          fetchGetQuestionerrorCorrectionListSuccess && fetchGetQuestionerrorCorrectionListSuccess.length > 0 &&
          <div className="my-correction-list">
            <List
              itemLayout="horizontal"
              size="large"
              pagination={{
                onChange: page => {
                  this.setState({
                    curPage: page,
                  }, () => {
                    this.onLoadMyCorrection();
                  })
                },
                current: this.state.curPage,
                total: fetchGetQuestionerrorCorrectionListTotal,
                pageSize: 5,
              }}
              loading={fetchGetQuestionerrorCorrectionListPending}
              dataSource={fetchGetQuestionerrorCorrectionListSuccess}
              renderItem={(item, key) => this.renderItem(item, key)}
            />
          </div>
        }
        {
          fetchGetQuestionerrorCorrectionListSuccess && fetchGetQuestionerrorCorrectionListSuccess.length === 0 &&
          <div className="noneData">
            <NoneData type={2} />
          </div>
        }
      </div>
    );
  }
}

/* istanbul ignore next */
function mapStateToProps(state) {
  return {
    center: state.center,
    common: state.common,
  };
}

/* istanbul ignore next */
function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({ ...actions }, dispatch)
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ExerRecordMyCorrection);



// WEBPACK FOOTER //
// ./src/features/center/ExerRecordMyCorrection.js